export default "/img/CA.667a7174b485c66ab786c948909e0d3e.png";